import { useState } from "react";
import {
  Card,
  Text,
  Collapsible,
  Button,
  Banner,
  Icon,
  Box,
  Divider,
} from "@shopify/polaris";
import { ChevronDownIcon, ChevronUpIcon } from "@shopify/polaris-icons";

export default function FAQ() {
    const [showInfo,setShowInfo] = useState(true);
  
  const faqs = [
    {
      question: "What is included in the free trial, and how long does it last?",
      answer: (
        <p>
          The <strong>eBay Professional Importer</strong> app offers a <strong>FREE</strong> trial, allowing you to import up to 5 eBay listings and access all features for one month. This gives you the opportunity to explore the app before committing to a paid plan.
        </p>
      )
    },
    {
      question: "Is there a cancellation policy, and can I cancel my subscription at any time?",
      answer: (
        <p>
          Yes, you can cancel your subscription at any time once your needs are met—whether you choose to stop using our service or no longer require it.
        </p>
      )
    },
    {
      question: "Can I switch to a higher plan later if my eBay inventory increases?",
      answer: (
        <p>
          Absolutely. As your eBay product catalog grows, you can upgrade to a higher plan at any time to support importing more products.
        </p>
      )
    },
    {
      question: "What payment methods do you support for subscribing to a plan?",
      answer: (
        <p>
          We accept payments exclusively through the Shopify billing system.
        </p>
      )
    },
    {
      question: "How does the product sync process work between eBay and Shopify?",
      answer: (
        <p>
          Price and quantity synchronization is available during the initial setup. You can choose one of the following sync directions:
          <br /><strong>1. eBay to Shopify – </strong> Syncs price and quantity from your eBay listings to your Shopify store.
          <br /><strong>2. Shopify to eBay – </strong> Syncs price and quantity from your Shopify products to your eBay listings.
        </p>
      )
    },
    {
      question: "Can I manage profiles in the app—such as editing, duplicating, or deleting them?",
      answer: (
        <p>
          Yes, you can perform all of these actions from the <strong>Profile</strong> section:
          <br /><strong>1. Edit – </strong> Modify an existing profile.
          <br /><strong>2. Copy – </strong> Create a duplicate profile named "Copy of [Your Profile Name]".
          <br /><strong>3. Delete – </strong> Permanently remove a profile.
          <br />Refer to the image provided for a step-by-step visual guide.
        </p>
      )
    },
    {
      question: "Is it possible to switch to a different eBay seller account within the app?",
      answer: (
        <p>
          Yes. On the dashboard, navigate to the <strong>eBay Account</strong> section and click the <strong>Change eBay Store</strong> link. This will redirect you to eBay, where you can connect a different account. Once authorized, your new eBay account will appear under the store name in the <strong>eBay Account</strong> section. For further assistance, please refer to the visual guide below.
        </p>
      )
    },
    {
      question: "Can I use the app to import any type of product from eBay?",
      answer: (
        <p>
          By default, the app imports active,schedule or inactive  listings from your eBay seller account. If you’d like to import Auction-style listings, Unsold items, or other types, please contact our support team.
          <br />Note: The app only imports listings from your own eBay seller account.
        </p>
      )
    },
    {
  question: "Why am I seeing a message that my eBay seller account needs additional information or verification?",
  answer: (
    <p>
      This usually means your eBay seller account is missing some required details or verification. To resolve this, follow the steps below:
      <br /><br />
      <strong>1. Verify Your Identity –</strong> eBay may require you to confirm your identity by submitting personal information or official documents.
      <br />
      <strong>2. Set Up Payment Information –</strong> Ensure that you have a valid payment method added to your account to handle eBay's seller fees.
      <br />
      <strong>3. Complete Missing Details –</strong> Visit the following link to fill in any remaining information: <a href="https://www.ebay.com/signin/" target="_blank" rel="noopener noreferrer">Sign in or Register | eBay</a>.
      <br /><br />
      After completing these steps, your account should be ready to use within 24 hours.
    </p>
  )
}
 

  ];


  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return (
    <div style={{ maxWidth: 1000, margin: "2rem auto" }}>
      <div style={{ marginBottom: "10px" }}>
        <Text variant="headingXl" as="h1" alignment="center">
          Frequently Asked Questions (FAQs)
        </Text>
      </div>

      <Box paddingBlockStart="4">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <div
              key={index}
              style={{
                marginBottom: "1rem",
                borderRadius: "12px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.08)",
                overflow: "hidden",
                background: "#fff",
              }}
            >
              <Button
                fullWidth
                onClick={() => toggleFAQ(index)}
                ariaExpanded={isOpen}
                ariaControls={`faq-${index}`}
                accessibilityLabel={`Toggle ${faq.question}`}
                textAlign="left"
                plain
                disclosure={isOpen ? "up" : "down"}
                removeUnderline
                style={{
                  fontWeight: 600,
                  padding: "1rem",
                  fontSize: "16px",
                  backgroundColor: "#f9fafb",
                }}
              >
                {faq.question}
              </Button>

              <Collapsible
                open={isOpen}
                id={`faq-${index}`}
                transition={{ duration: "300ms", timingFunction: "ease" }}
              >
                <div style={{ padding: "1rem", background: "#ffffff" }}>
                  <Text variant="bodyMd" as="div" tone="subdued">
                    {faq.answer}
                  </Text>
                </div>
              </Collapsible>
            </div>
          );
        })}
      </Box>
    </div>
  );
}
